<div class="detail-view-area-ticket margin-bottom-20">
    <ng-container *ngIf="(bookingStatus$ | async) !== 'pending'">
        <ng-container *ngIf="!env.IS_CORPORATE">
            <ng-container *ngFor="let dn of docNums$ | async">
                <section attr.aria-label="{{ 'TICKET_GROUP_INFO_ARIA_LABEL' | translate }}">
                    <ridango-ticket
                        [ticket]="(cart$ | async).ticketsByDocNum[dn]"
                        [locale]="locale"
                        [transportDayEndPrevDate]="transportDayEndPrevDate"
                        [hasZoneModal]="env.TICKET_HAS_ZONE_MODAL"
                        [assetsPath]="assetsPath$ | async">
                    </ridango-ticket>
                </section>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="env.IS_CORPORATE">
            <ng-container *ngFor="let groupedTicket of groupedTicketsByProduct$ | async">
                <section attr.aria-label="{{ 'TICKET_GROUP_INFO_ARIA_LABEL' | translate }}">
                    <ridango-ticket
                        [ticket]="groupedTicket"
                        [locale]="locale"
                        [productType]="groupedTicket.product.product_type"
                        [ticketsByDocNums]="(cart$ | async).ticketsByDocNum"
                        [transportDayEndPrevDate]="transportDayEndPrevDate"
                        [hasZoneModal]="env.TICKET_HAS_ZONE_MODAL"
                        [assetsPath]="assetsPath$ | async">
                    </ridango-ticket>
                </section>
            </ng-container>
        </ng-container>

    </ng-container>

    <ng-container *ngIf="(bookingStatus$ | async) === 'pending'">
        <section attr.aria-label="{{ 'TICKET_GROUP_INFO_ARIA_LABEL' | translate }}">
            <rwidget-booking-ticket
                [plan]="plan$ | async"
                [passengerPermission]="passengerPermission$ | async"
                [specification]="specification$ | async"
                [estimatedPrice]="estimatedPrice$ | async"
                [isPending]="true"
                [label]="'BOOKINGS_PAGE_LABEL_PENDING_BOOKINGS' | translate"
                [customerProfile]="profile$ | async">
            </rwidget-booking-ticket>
        </section>
    </ng-container>
</div>
